export default __webpack_public_path__ + "static/media/contact-anim.b82d0eb1.gif";